import { Component, Inject, ModelSync, Prop, Vue } from 'vue-property-decorator'
import { Validator } from 'vee-validate'

@Component
export default class ConfigurationAutomationPersonnelAlgorithmsSelectionFormElement<Option = any> extends Vue {
    @ModelSync('value', 'input', { type: Object })
    selectedValue!: Option

    /**
     * Array of available options
     */
    @Prop({
        type: Array,
        required: true
    })
    readonly options!: Array<Option>

    /**
     * Key to compare options objects
     */
    @Prop({
        type: String,
        required: true
    })
    readonly title!: string

    /**
     * Key to compare options objects
     */
    @Prop({
        type: String,
        default: 'id'
    })
    readonly trackBy!: keyof Option

    /**
     * Label to look for in option Object
     */
    @Prop({
        type: String,
        default: 'label'
    })
    readonly label!: keyof Option

    @Prop({
        type: String
    })
    readonly testing!: string

    @Inject() externalValidator!: Validator

    constructor() {
        super()

        this.$validator = this.externalValidator
    }
}
